import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Commessa, TipoCliente, TipoIntervento, Utente, OrdineLavoro, Autista, Mezzo } from 'src/app/def/structures';
import { DBFirestoreService } from 'src/app/dbfirestore.service';
import { BatchOperation } from 'src/app/def/types';
import { count } from 'rxjs/operators';

@Component({
    selector: 'app-ordini',
    templateUrl: './ordini.component.html',
    styleUrls: ['./ordini.component.scss']
})
export class OdlAdminOrdiniComponent implements OnInit {

    public assetsdata = '2018.json';
    constructor(
        private http: HttpClient,
        private db: DBFirestoreService,
    ) { }

    ngOnInit() {
    }

    import() {

        this.http.get('/assets/data/' + this.assetsdata ).subscribe((data: any[]) => {
            let i = 0, j = 0;
            const chunks = [], size = 100;
            for (i = 0, j = data.length; i < j; i += size) {
                chunks.push(data.slice(i, i + size));
            }
            // console.log(chunks);
            
            console.log(chunks.length);
            chunks.forEach(chunk => {
                const ops: BatchOperation[] = [];
                chunk.forEach(row => {
                    // console.log(row);
                    const new_commessa: Commessa = {
                        id: this.db.createId(),
                        cliente: row.cliente,
                        data_ricezione: this.strToDate(row.data_ricezione),
                        indirizzo: row.indirizzo,
                        localita: row.localita,
                        note: row.note,
                        persona_riferimento: row.persona_riferimento,
                        telefono: row.telefono,

                        tipo_cliente: row.tipo_cliente ? { id: row.tipo_cliente.replace('/tipi_cliente/', '') } as TipoCliente : null,
                        tipo_intervento: row.tipo_intervento ? { id: row.tipo_intervento.replace('/tipi_intervento/', '') } as TipoIntervento : null,
                        utente: row.utente ? { id: row.utente.replace('/utenti/', '') } as Utente : null,

                        numero_ordini: row.giorni.length,
                    }
                    ops.push(
                        this.db.batchSetCommessa(new_commessa)
                    )
                    row.giorni.forEach( giorno => {
                        const new_giorno: OrdineLavoro = {
                            id: null,
                            attrezzi: giorno.attrezzi,
                            autista: giorno.autista ? {id: giorno.autista.replace('/autisti/','')} as Autista : null,
                            caposquadra: giorno.caposquadra ? {id: giorno.caposquadra.replace('/autisti/','' )} as Autista : null,
                            confermato: (giorno.confermato && giorno.confermato === '1'),
                            durata_prevista: giorno.durata_prevista,
                            giorno_ora: this.strToDateTime(giorno.giorno,giorno.ora),
                            indirizzo: giorno.indirizzo,
                            localita: giorno.localita,
                            mezzo: giorno.mezzo ? {id: giorno.mezzo.replace('/mezzi/','')} as Mezzo : null,
                            note: giorno.note,
                            persona_riferimento: giorno.persona_riferimento,
                            telefono: giorno.telefono,
                            rif_commessa: new_commessa.id,

                            tipo_cliente: new_commessa.tipo_cliente ? new_commessa.tipo_cliente.id : null,
                            tipo_intervento: new_commessa.tipo_intervento ? new_commessa.tipo_intervento.id : null,
                        }
            
                        ops.push(
                            this.db.batchAddOrdine(new_giorno)
                        )
                    });

                });

                this.db.batch(ops).then( () => {
                    console.log('ok');
                }).catch(error => {
                    console.log('error',error);
                })

            });

        });

    }

    strToDate(str: string): Date {
        const [yyyy, mm, dd] = str.split('-');
        const date = new Date();
        date.setDate(1); // Temporaneamente impostiamo un giorno valido per qualunque mese/anno
        date.setFullYear(parseInt(yyyy));
        date.setMonth(parseInt(mm) - 1);
        date.setDate(parseInt(dd));
        return date;
    }

    strToDateTime(str, stime): Date {
        const [yyyy, mm, dd] = str.split('-');
        const [hh,min,sec] = stime ? stime.split(':') : [0,0,0];
        const date = new Date();
        date.setDate(1); // Temporaneamente impostiamo un giorno valido per qualunque mese/anno
        date.setFullYear(parseInt(yyyy));
        date.setMonth(parseInt(mm) - 1);
        date.setDate(parseInt(dd));
        date.setHours(parseInt(hh));
        date.setMinutes(parseInt(min));
        date.setSeconds(parseInt(sec));
        return date;
    }
}
